import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import Input from "components/Input";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from "assets/icons/close.svg?react";
import classNames from "classnames";

const CourtPortalCaseInfo: FC<Props> = ({ toggle, source }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t("cases.caseDetails")}
        <CloseIcon
          onClick={() => {
            toggle(false);
          }}
          className={styles.closeIcon}
        />
      </div>

      <div className={styles.inputs}>
        {/* <div className={styles.statuses}>
          <SelectFlagNew
            selectedStatus={status}
            onChoose={(status) => setStatus(status)}
          />
        </div> */}

        <Input
          disabled={true}
          placeholder={t("cases.court")}
          onChange={() => {}}
          label={t("cases.court")}
          value={source.Court}
        />

        <Input
          disabled={true}
          label={t("cases.department")}
          onChange={() => {}}
          value={source.Department}
        />

        {source.Client && (
          <Input
            disabled={true}
            label={t("cases.client")}
            onChange={() => {}}
            value={""}
          />
        )}

        {source.JudgeName && (
          <Input
            disabled={true}
            label={t("cases.referent")}
            onChange={() => {}}
            value={source.JudgeName}
          />
        )}

        {source.Value && (
          <Input
            disabled={true}
            label={t("cases.disputeValue")}
            onChange={() => {}}
            value={source.Value}
          />
        )}

        {source.Result && (
          <Input
            disabled={true}
            label={t("cases.resolution")}
            onChange={() => {}}
            value={source.Result}
          />
        )}
      </div>

      <div className={styles.history}>
        <div className={styles.list}>
          <div className={styles.box}>
            <div className={styles.boxWrapper}>
              <div className={styles.line}></div>
              <FontAwesomeIcon
                className={classNames(styles.avatar)}
                icon={faCircle}
              />

              <div className={styles.boxContent}>
                <div className={styles.r1}>{t("cases.dateReceived")}</div>
                <div className={styles.r2}>
                  <div className={styles.date}>
                    {moment(source.CreationDate).format("DD.MM.yyyy | HH:mm")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {source.ReceipDate && (
            <div className={styles.box}>
              <div className={styles.boxWrapper}>
                <div className={styles.line}></div>
                <FontAwesomeIcon
                  className={classNames(styles.avatar)}
                  icon={faCircle}
                />

                <div className={styles.boxContent}>
                  <div className={styles.r1}>{t("cases.piPublicationDate")}</div>
                  <div className={styles.r2}>
                    <div className={styles.date}>
                      {moment(source.ReceipDate).format("DD.MM.yyyy | HH:mm")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {source.FinishDate && (
            <div className={styles.box}>
              <div className={styles.boxWrapper}>
                <div className={styles.line}></div>
                <FontAwesomeIcon
                  className={classNames(styles.avatar)}
                  icon={faCircle}
                />
                <div className={styles.boxContent}>
                  <div className={styles.r1}>{t("cases.piPublicationDate")}</div>
                  <div className={styles.r2}>
                    <div className={styles.date}>
                      {moment(source.FinishDate).format("DD.MM.yyyy | HH:mm")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CourtPortalCaseInfo;
